import styled from "styled-components";
import {responsive} from "../../media-quries";
import {RingEmpty} from "../home-page/landing/landing.components";
import {Link} from "react-router";

const Wrapper = styled.div`
  position: relative;
  margin-top: 160px;
  background: var(--chakra-colors-primary);
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
`;
export const Top = styled.div`
  position: absolute;
  left: 50%;
  top: -98px; 
  transform: translateX(-50%);
  width: 100vw;
  height: 100px;
  background: var(--chakra-colors-primary);;
  clip-path: polygon(0 100%, 100% 100%, 100% 50px, 0 0); /* Definicja kształtu */
`;
const Container = styled.footer`
  margin: auto;
  color: white;
  padding-bottom: 24px;
  display: flex;
  flex-wrap: wrap;
  position: relative;

  /* Mobile: Do 767px */
  @media (max-width: 767px) {
    & {
      max-width: 100%;
      padding: 0 16px;
    }
  }

  /* Tablet: 768px - 1023px */
  @media (min-width: 768px) and (max-width: 1023px) {
    & {
      max-width: 720px;
    }
  }

  /* Laptop: 1024px - 1279px */
  @media (min-width: 1024px) and (max-width: 1279px) {
    & {
      max-width: 960px;
    }
  }

  /* Desktop: 1280px - 1919px */
  @media (min-width: 1280px) and (max-width: 1919px) {
    & {
      max-width: 1140px;
    }
  }

  /* Large Desktop: 1920px i więcej */
  @media (min-width: 1920px) {
    & {
      max-width: 1440px;
    }
  }
`;
const LeftSection = styled.div`
  max-width: 50%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-right: 1px solid white;
  padding-right: 30px;

  ${responsive.sm`
    max-width: 100%;
    border-right: none;
  `}
`;
const RightSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;

  ${responsive.sm`
      align-items: center;
      flex: 1;
    text-align: center;
  `}
`;
const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
`;
const Description = styled.p`
  font-size: 13px;
`;
const StyledLink = styled(Link)`
  &:hover {
    font-weight: 600;
  }
`;
const Copyright = styled.div`
  margin-top: 16px;
  width: 100%;
  text-align: center;
`;
const Ring1 = styled(RingEmpty)`
  width: 120px;
  height: 120px;
  top: 0;
  left: -50px;
`;
const Ring2 = styled(RingEmpty)`
  width: 150px;
  height: 150px;
  bottom: 0px;
  right: -40px;

  ${responsive.sm`
    display: none;
  `}
`;
const Ring3 = styled(RingEmpty)`
  width: 80px;
  height: 80px;
  top: 0px;
  left: 60%;
  z-index: 5;
`;

function Footer() {

    return <Wrapper>
        <Top />
        <Container>
            <LeftSection>
                <Title>Geoksiegi.pl</Title>
                <Description>
                    Nasz serwis to intuicyjne narzędzie umożliwiające wyszukiwanie numerów ksiąg wieczystych dla działek, budynków, lokali, garaży oraz mieszkań. Dzięki zaawansowanemu systemowi możesz odnaleźć potrzebne informacje, wpisując adres, identyfikator działki lub jej numer. Ułatwiamy dostęp do kluczowych danych nieruchomości, gwarantując szybkie i precyzyjne wyniki wyszukiwania.
                </Description>
            </LeftSection>
            <RightSection>
                <nav aria-label="Stopka - linki">
                    <ul>
                        <li><StyledLink to="/" >Strona główna</StyledLink></li>
                        <li><StyledLink to="/cennik" >Cennik</StyledLink></li>
                        <li><StyledLink to="/polityka-prywatnosci" >Polityka prywatności</StyledLink></li>
                        <li><StyledLink to="/regulamin" >Regulamin</StyledLink></li>
                        <li><StyledLink to="/baza-wiedzy" >Baza wiedzy</StyledLink></li>
                        <li><StyledLink to="/kontakt" >Kontakt</StyledLink></li>
                    </ul>
                </nav>
            </RightSection>
            <Copyright>
                © {new Date().getFullYear()} Geoksiegi.pl.
            </Copyright>
        </Container>
        <Ring1 />
        <Ring2 />
        <Ring3 />
    </Wrapper>
}

export default Footer;
